import React from 'react';

export const CsrLoading = ({ label = 'Loading CSR Impact dashboard', blocks = [180, 520], kpis = 6 }) => (
  <div aria-busy="true" aria-label={label} className="d-flex flex-column" style={{ gap: 20 }}>
    <div className="csr-kpis">{Array.from({ length: kpis }).map((_, i) => <div key={i} className="csr-skel" style={{ height: 96 }} />)}</div>
    {blocks.map((h, i) => <div key={i} className="csr-skel" style={{ height: h }} />)}
  </div>
);

export const CsrError = ({ message, onRetry }) => (
  <section className="csr-card csr-notice" role="alert">
    <span className="csr-chip csr-chip--amber csr-chip--caps">Unavailable</span>
    <h2>Dashboard could not be loaded</h2>
    <p>{message}</p>
    <button type="button" className="csr-btn" onClick={onRetry}>Retry</button>
  </section>
);

export const CsrInlineError = ({ message, onRetry }) => (
  <p className="csr-inline-warn" role="alert">
    {message}
    {onRetry ? <> <button type="button" className="csr-link" onClick={onRetry}>Retry</button></> : null}
  </p>
);

export const UnderReviewNotice = () => (
  <div className="csr-review" role="status">
    <strong>🚨 REPORT STATUS: UNDER REVIEW</strong>
    <p>One or more results require verification. Please contact our technical support team. Repeat testing may be required before the final report is issued!</p>
  </div>
);
